import { AuthPostResponse as ResPost } from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/types/POST";
import { AuthGetResponse as ResGet } from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/types/GET";
import { AuthDeleteResponse as ResDelete } from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/types/DELETE";
import { FromDtoFn } from "src/business.InterfaceLayer/store/types/FromDtoFn.type";
import { convertToServerResponse } from "src/business.InterfaceLayer/store/services/utils.service/convertToServerResponse";
import { AUTH_FIELDS } from "../../../redux/fields";
import convertProfileUtil from "./utils/convertProfile.util";
import COMMON_FIELDS from "../../../../../../../general/constants/commonFields";

export namespace AuthFromDtoPost {
	export const authRegistrationFromDto: FromDtoFn<ResPost.AuthLogin> = (
		props,
		meta
	) => {
		return props
			? convertToServerResponse(props, meta, {
					[AUTH_FIELDS.TOKEN_ACCESS]: props?.data?.token,
					[AUTH_FIELDS.TOKEN_REFRESH]: props?.data?.refresh_token,
					[AUTH_FIELDS.IS_NEED_CHANGE]: props?.data?.isNeedChange
						? "true"
						: "false",
					[AUTH_FIELDS.ROLE]: props?.data?.owner?.roles,
					[AUTH_FIELDS.USER_ID]: props?.data?.owner?.id || null,
			  })
			: null;
	};

	export const authRegistrationCheckEmailFromDto: FromDtoFn<
		ResPost.AuthRegistrationCheckEmail
	> = (props, meta) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};

	export const authLoginFromDto: FromDtoFn<ResPost.AuthLogin> = (
		props,
		meta
	) => {
		return props
			? convertToServerResponse(props, meta, {
					[AUTH_FIELDS.TOKEN_ACCESS]: props?.data?.token,
					[AUTH_FIELDS.TOKEN_REFRESH]: props?.data?.refresh_token,
					[AUTH_FIELDS.IS_NEED_CHANGE]: props?.data?.isNeedChange
						? "true"
						: "false",
					[AUTH_FIELDS.ROLE]: props?.data?.owner?.roles,
					[AUTH_FIELDS.USER_ID]: props?.data?.owner?.id || null,
			  })
			: null;
	};

	export const guestAuthLoginFromDto: FromDtoFn<ResPost.GuestAuthLogin> = (
		props,
		meta
	) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};

	export const recoveryPasswordEmailFromDto: FromDtoFn<
		ResPost.RecoveryPasswordEmail
	> = (props, meta) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};

	export const recoveryPasswordFromDto: FromDtoFn<ResPost.RecoveryPassword> = (
		props,
		meta
	) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};
}

export namespace AuthFromDtoGet {
	export const authGetMeFromDto: FromDtoFn<ResGet.AuthGetMe> = (
		props,
		meta
	) => {
		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.DATA]: convertProfileUtil(props),
			  })
			: null;
	};
}

export namespace AuthFromDtoDelete {
	export const authDeleteAccountFromDto: FromDtoFn<ResDelete.AuthDelete> = (
		props,
		meta
	) => {
		return props ? convertToServerResponse(props, meta, {}) : null;
	};
}
